<div class="card">
  <div class="card-body py-3 px-4" style="position: relative; min-height: 230px;">
    <div class="h5-text card-title mr-2 d-inline-block">{{profile.Name}}</div>
    @if (!profile.AdvisorType && canUpdateContact) {
      <button class="btn btn-outline-primary update-button"
        (click)="showTheForm()"
      >Request Update</button>
    }
    @if (profile.AdvisorType) {
      <p class="mb-3 font-italic small">
        {{profile.AdvisorType}}
        @if (isPgf) {
          <span>Advisor</span>
        }
        @if (!isPgf && clientsList !== '') {
          <span >{{clientsList}}</span>
        }
      </p>
    }

    @if (profile.EmailAddress) {
      <div >
        <span class="fa fa-envelope" style="width: 24px"></span>
        <span>{{profile.EmailAddress}}</span>
      </div>
    }
    @if (profile.PhoneNumber) {
      <div>
        <span class="fa fa-phone" style="width: 24px"></span>
        <span>{{profile.PhoneNumber}}</span>
      </div>
    }
    @if (profile.Fax) {
      <div>
        <span class="fa fa-fax" style="width: 24px"></span>
        <span>{{profile.Fax}} (fax)</span>
      </div>
    }
    @if (addressLines.length > 0) {
      <div class="mt-3 mb-3">
        <span class="fa fa-map-marker" style="width: 24px"></span>
        <b>Mailing Address</b>
        <div class="ml-4">
          @for (address of addressLines; track address) {
            <div>
              {{address}}
            </div>
          }
        </div>
      </div>
    }
  </div>

</div>
